import React from "react";
import {
  BannerWrapper,
  Container,
  TextSubTitle,
  TextTitle,
} from "../PaymentSuccess/PaymentSuccess.styled";

import { func } from "../../../../utils";
import _function from "../../../../utils/function";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CardInfo from "./CardInfo";
import Lottie from "react-lottie";
import animationData from "./animationdata.json";
import Show from "../../../atoms/Show/Show";

const RegistrationSuccess = ({ data, slug, children }) => {
  const { size } = useWindowSize();
  const navigate = useNavigate();

  const { city } = useParams();
  const kota = city.charAt(0).toUpperCase() + city.slice(1);
  const isMobileView = (size?.width || 0) <= 830;

  const location = useLocation();
  const actionWording = location?.state?.action ?? "registrasi";

  const MobileBanner = () => {
    return (
      <>
        <Container
          justifyContent={"center"}
          display={"flex"}
          flexDirection={"column"}
          style={{ textAlign: "center", alignItems: "center" }}
        >
          <img
            src={func.getStaticImg("bg/bg-success-payment-m.svg")}
            alt="backdrop"
            className="w-full absolute left-0 bottom-[420px] h-[500px]"
          />
          {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}

          <Lottie
            options={{
              animationData: animationData,
            }}
            style={{ width: 100.467, height: 99.733, marginTop: "10svh" }}
          />

          <Show when={actionWording === "add-player"}>
            <TextTitle
              className="absolute text-white"
              style={{ color: "#1F2D3D", marginTop: "28vh" }}
            >
              Data Pemain Berhasil <br /> Ditambahkan
            </TextTitle>
            <TextSubTitle
              className="absolute text-white left-0 right-0"
              fontSize={"16px"}
              style={{
                color: "#1F2D3D",
                fontWeight: "400",
                marginTop: "44svh",
              }}
            >
              Siapkan tim kamu untuk menghadapi pertandingan yang akan datang
            </TextSubTitle>
          </Show>
          <Show when={actionWording !== "add-player"}>
            {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}
            <TextTitle
              className="absolute text-white"
              style={{ color: "#1F2D3D", marginTop: "220px" }}
            >
              Yeay! Registrasi berhasil
            </TextTitle>
            <TextSubTitle
              className="absolute text-white"
              fontSize={"16px"}
              style={{
                color: "#1F2D3D",
                fontWeight: "400",
                marginTop: "340px",
              }}
            >
              Kamu berhasil mendaftarkan tim <br /> kamu di Piala by.U {kota}
              {/* Berhasil {actionWording} <br /> Piala by.U {kota} */}
            </TextSubTitle>
          </Show>
        </Container>
        <div className="absolute lg:top-[35svh] top-[270px] left-0 right-0">
          <Container justifyContent={"center"} display={"flex"} style={{ marginTop: "40px" }}>
            <CardInfo isMobileView />
          </Container>
        </div>
      </>
    );
  };

  const DesktopBanner = () => {
    return (
      <>
        <img
          src={func.getStaticImg("bg/bg-success-payment.svg")}
          alt="backdrop"
          className="w-full absolute top-0 left-0"
        />
        <Lottie
          options={{
            animationData: animationData,
          }}
          style={{
            width: 110,
            height: 110,
            position: "absolute",
            top: "65px",
            left: 0,
            right: 0,
          }}
        />
        <div
          className="absolute top-[350px] bottom-0 left-0 w-full h-full"
          style={{
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            //alignItems: "center",
            textAlign: "center",
          }}
        >
          <Show when={actionWording === "add-player"}>
            <TextTitle className="!text-[20px] text-white !leading-none whitespace-pre">
              {`Data Pemain Berhasil Ditambahkan`}
            </TextTitle>
            <TextSubTitle className="!text-[20px] text-white !leading-none !font-normal mt-4">
              Siapkan tim kamu untuk menghadapi pertandingan yang akan datang
            </TextSubTitle>
          </Show>
          <Show when={actionWording !== "add-player"}>
            {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}
            <TextTitle className="!text-[20px] text-white !leading-none">
              Yeay! Registrasi berhasil
            </TextTitle>
            <TextSubTitle className="!text-[20px] text-white !leading-none !font-normal mt-4">
              Kamu berhasil mendaftarkan tim kamu di Piala by.U {kota}
              {/* Berhasil {actionWording} <br /> Piala by.U {kota} */}
            </TextSubTitle>
          </Show>
        </div>
        <div
          style={{
            margin: "auto",
            maxWidth: "1440px",
            display: "flex",
            gap: 160,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="absolute top-[270px]">
            <Container justifyContent={"center"} display={"flex"} flexDirection="column">
              <Container justifyContent={"center"} display={"flex"}>
                <CardInfo isMobileView />
              </Container>
            </Container>
          </div>
        </div>
      </>
    );
  };

  return (
    <BannerWrapper
      id="banner"
      backgroundImage={func.getStaticImg(isMobileView ? "none" : "none")}
      zIndex={2}
      position="relative"
      border={"1px transparent"}
      height={"800px"}
      className="lg:max-w-[1366px] max-w-[375px] mx-auto"
    >
      {isMobileView ? <MobileBanner /> : <DesktopBanner />}
    </BannerWrapper>
    // <div className="flex items-center justify-center min-h-screen bg-blue-50">
    //   <div className="bg-white rounded-2xl shadow-lg p-6 max-w-lg text-center">
    //     <div className="flex flex-col items-center">
    //       <div className="bg-green-500 p-3 rounded-full">
    //         {/* <CheckCircle className="text-white w-10 h-10" /> */}
    //       </div>
    //       <h2 className="text-xl font-semibold text-gray-800 mt-4">
    //         Bukti Pembayaran Berhasil Diupload
    //       </h2>
    //       <p className="text-gray-600 mt-2 text-sm">
    //         Tim by.U akan segera mengonfirmasi status pembayaran
    //       </p>
    //       <div className="bg-yellow-100 p-4 rounded-lg flex items-center mt-4 border border-yellow-300">
    //         {/* <AlertTriangle className="text-yellow-500 w-6 h-6 mr-2" /> */}
    //         <p className="text-yellow-800 text-sm text-left">
    //           <strong>Bukti Pembayaran Sedang Dikonfirmasi</strong>
    //           <br /> Konfirmasi status pembayaran dapat dilihat di Dashboard
    //         </p>
    //       </div>
    //       <button className="mt-6 bg-blue-500 text-white px-6 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600 shadow-md">
    //         Lihat Dashboard
    //       </button>
    //     </div>
    //   </div>
    // </div>
  );
};

export default RegistrationSuccess;
